var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetricActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/weight"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M5 20H13C16 20 18 18 18 15V5C18 2 16 0 13 0H5C2 0 0 2 0 5V15C0 18 2 20 5 20Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5 5.99973C11.37 3.20973 6.63998 3.20973 3.49998 5.99973C3.35998 6.12973 3.32998 6.32973 3.42998 6.47973L5.60998 9.97973C5.66998 10.0697 5.76998 10.1397 5.86998 10.1497C5.97998 10.1697 6.08998 10.1297 6.16998 10.0597C7.77998 8.62973 10.2 8.62973 11.81 10.0597C11.88 10.1197 11.97 10.1497 12.06 10.1497C12.08 10.1497 12.1 10.1497 12.11 10.1497C12.22 10.1297 12.32 10.0697 12.37 9.97973L14.55 6.47973C14.67 6.32973 14.64 6.12973 14.5 5.99973Z",
    fill: "#1DD899"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricActive);
export default __webpack_public_path__ + "static/media/metricActive.0ab5bb9cc3d16a0fef67a5c8b045dc4b.svg";
export { ForwardRef as ReactComponent };